<template>
  <div class="suggestion-details-campaigns">
    <div class="sdc__header">
      <h3 class="m-0">{{ $tc('_campaign', 2) }}</h3>
      <button v-show="hasCampaign" class="btn btn-link sdc__add-campaign" @click="openModal">
        {{ $t('campaigns.create.add-campaign') }}
      </button>
    </div>

    <template v-if="getLoadingCampaigns">
      <div class="sdc__table customScrollBar">
        <div class="table">
          <div class="table__header">
            <div class="table__row">
              <div class="table__column">
                <div class="table__header-title">
                  {{ $t('name') }}
                </div>
              </div>
              <div class="table__column">
                <div class="table__header-title">{{ $tc('_message', 1) }}</div>
              </div>
              <div class="table__column text-right">
                <div class="table__header-title">{{ $t('people') }}</div>
              </div>
              <div class="table__column text-right">
                <div class="table__header-title">{{ $t('campaigns.create.limits') }}</div>
              </div>
              <div class="table__column text-right">
                <div class="table__header-title">{{ $t('campaigns.create.status') }}</div>
              </div>
            </div>
          </div>

          <div class="table__body">
            <div class="table__row table__row--first" style="align-items: flex-start">
              <div :class="['table__column text-left']">
                <el-skeleton :loading="true" animated>
                  <template #template>
                    <el-skeleton-item
                      variant="p"
                      style="height: 10px; width: 110px; display: block; margin-bottom: 8px"
                    />
                    <el-skeleton-item
                      variant="p"
                      style="height: 10px; width: 140px; display: block; margin-bottom: 8px"
                    />
                    <el-skeleton-item variant="p" style="height: 10px; width: 180px; display: block" />
                  </template>
                </el-skeleton>
              </div>
              <div :class="['table__column text-left']">
                <el-skeleton :loading="true" animated>
                  <template #template>
                    <el-skeleton-item variant="p" style="height: 10px; width: 40px; margin-top: 8px" />
                  </template>
                </el-skeleton>
              </div>
              <div :class="['table__column']">
                <el-skeleton :loading="true" animated>
                  <template #template>
                    <el-skeleton-item variant="p" style="height: 10px; width: 40px; margin-top: 8px" />
                  </template>
                </el-skeleton>
              </div>

              <div :class="['table__column']">
                <el-skeleton :loading="true" animated>
                  <template #template>
                    <el-skeleton-item variant="p" style="height: 10px; width: 40px; margin-top: 8px" />
                  </template>
                </el-skeleton>
              </div>

              <div class="table__column">
                <el-skeleton :loading="true" animated>
                  <template #template>
                    <el-skeleton-item variant="p" style="height: 10px; width: 40px; margin-top: 8px" />
                  </template>
                </el-skeleton>
              </div>

              <div class="table__column">
                <el-skeleton :loading="true" animated>
                  <template #template>
                    <el-skeleton-item variant="p" style="height: 10px; width: 20px; margin-top: 8px" />
                  </template>
                </el-skeleton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>

    <template v-if="hasCampaign && !getLoadingCampaigns">
      <div class="sdc__table customScrollBar">
        <div class="table">
          <div class="table__header">
            <div class="table__row">
              <div class="table__column">
                <div class="table__header-title">
                  {{ $t('name') }}
                </div>
              </div>
              <div class="table__column">
                <div class="table__header-title">{{ $tc('_message', 1) }}</div>
              </div>
              <div class="table__column text-right">
                <div class="table__header-title">{{ $t('people') }}</div>
              </div>
              <div class="table__column text-right">
                <div class="table__header-title">{{ $t('campaigns.create.limits') }}</div>
              </div>
              <div class="table__column text-right">
                <div class="table__header-title">{{ $t('campaigns.create.status') }}</div>
              </div>
            </div>
          </div>

          <div class="table__body">
            <div v-for="(item, index) in campaignsList" :key="item.id" class="table__row table__row--first">
              <div :class="['table__column text-left']">
                <strong class="suggestion-details-campaigns__audience-name" :title="item.name">{{ item.name }} </strong
                ><br />
                <span>
                  <div v-if="item.audience">
                    {{ $t('campaigns.audience') }}:
                    <a
                      :title="item.audience.name"
                      :href="`/base-management/base-audiences/view/${this.$store.getters.user.id}/${item.audience.id}`"
                      target="_blank"
                      >{{ item.audience.name }}</a
                    >
                  </div>
                  <p v-else>-</p>
                </span>
                <span> {{ $t('360.campaigns.details.label-rule') }}: {{ getNameRule(item.sellerAllocation) }} </span>
              </div>
              <div :class="['table__column text-left']">
                <el-popover v-if="item.totalTemplates" effect="dark" trigger="hover" placement="top" :width="300">
                  <div style="font-size: 12px">
                    <strong> {{ $t('360.campaigns.details.recent') }} </strong><br /><br />
                    <span v-html="item.templates[0].text.replaceAll('\n', '<br />')"></span>
                  </div>
                  <template #reference>
                    <span class="suggestion-details-campaigns__total-message" @click="editCampaign(item, index)">
                      <img src="@/assets/svgs/Chat.svg" />{{ item.totalTemplates }}</span
                    >
                  </template>
                </el-popover>

                <div v-else class="suggestion-details-campaigns__empty-message">
                  <img src="@/assets/svgs/InfoEmpty.svg" />

                  <div>
                    <span v-html="$t('360.campaigns.details.empty-message')"></span>

                    <router-link
                      v-if="item.id"
                      :to="{
                        path: '/campaigns/messages',
                        query: { id: item.id },
                      }"
                      target="_blank"
                    >
                      {{ $t('add') }}
                    </router-link>
                  </div>
                </div>
              </div>
              <div
                :class="['table__column']"
                :title="item.audience?.count ? formatValues(item.audience?.count) : $t('360.check-marketing-cloud')"
                style="white-space: wrap"
              >
                {{
                  item.audience?.count === 0 && item.audience?.id === 0
                    ? $t('360.check-marketing-cloud')
                    : formatValues(item.audience?.count)
                }}
              </div>

              <VTooltip :class="['sdc__tooltip table__column']">
                <a>{{ typeText(item.limitType) }}</a>

                <template #popper>
                  <div class="content">
                    <div class="title">
                      <span>{{ typeText(item.limitType) }}</span>
                    </div>
                    <div>
                      <span v-if="item.limitType !== 'store_seller'">
                        {{ `${resolveContent(item)} ${$tc('_suggestions', 2)}` }}
                      </span>
                      <span v-else v-html="resolveContentStoreSeller(item)"></span>
                    </div>
                  </div>
                </template>
              </VTooltip>

              <div class="table__column">
                <span>
                  <span class="bol" :class="`status-${item.status}`"></span>
                  {{ $t(`campaigns.create.status-code.${item.status}`) }}
                </span>
              </div>

              <div class="table__column">
                <campaigns-management-details-campaign-dropdown
                  :campaign="item"
                  :enabled="item.status"
                  :index="index"
                  :hasSuggestions="item.hasSuggestions"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-if="!hasCampaign && !getLoadingCampaigns">
      <div class="sdc__empty-wrapper">
        <p class="m-0">
          {{ $t('campaigns.create.empty-campaigns') }}
        </p>
        <button class="btn btn-link sdc__add-campaign" @click="openModal">
          {{ $t('campaigns.create.create-campaign') }}
        </button>
      </div>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import bus from '@/helpers/events/bus';
import '@/plugins/tooltip/tooltip';
import { formatNumber } from '@/utilities/formatters';
import CampaignsManagementDetailsCampaignDropdown from '@/components/oto/campaignsManagement/_molecules/CampaignsManagementDetailsCampaignDropdown';
import i18n from '@/i18n';

export default {
  name: 'CampaignsManagementDetailsCampaigns',
  components: {
    CampaignsManagementDetailsCampaignDropdown,
  },
  computed: {
    ...mapGetters('campaignsManagement', ['getSuggestionDetail', 'getLimitsSelectOptions', 'getLoadingCampaigns']),

    campaignsList() {
      return this.getSuggestionDetail.campaigns || [];
    },
    hasCampaign() {
      return this.campaignsList && this.campaignsList.length > 0;
    },
  },
  mounted() {
    localStorage.removeItem('campaign-message-created');

    window.addEventListener('storage', event => {
      if (event.key === 'campaign-message-created') {
        this.updateActionCampaigns(this.$route.params.id);
      }
    });
  },
  methods: {
    ...mapActions('campaignsManagement', ['updateActionCampaigns']),

    editCampaign(campaign, index) {
      bus.$emit('open-suggestion-detail-campaigns-modal', {
        campaign: campaign,
        index: index,
        isEdit: true,
      });
    },

    openModal() {
      bus.$emit('open-suggestion-detail-campaigns-modal');
    },

    getNameRule(value) {
      const rules = [
        { key: 'main', value: 0 },
        { key: 'seller', value: 1 },
      ];

      const rule = rules.find(rule => rule.value === value);

      return i18n.global.tc(`360.campaigns.details.rules.${rule.key}`);
    },

    formatValues(val) {
      return formatNumber(val);
    },
    typeText(typeId) {
      const pathI18n = this.getLimitsSelectOptions[typeId];
      return pathI18n ? i18n.global.t(pathI18n) : '-';
    },
    resolveContent(item) {
      return item?.limitData?.limitValue ? item?.limitData?.limitValue : 0;
    },
    resolveContentStoreSeller(item) {
      const contentLimitValue = item.limitData
        .map(
          (item, index) =>
            `<p>
                <b>${i18n.global.t('group')} ${index + 1}:</b>
                ${item.limitValue} ${i18n.global.tc('campaigns.detail.suggestion', 2)}
              </p>`,
        )
        .join('');
      const title = `
          <div class="content">
            <div class="title">
            <div>
            <p>${contentLimitValue}</p>
          </div>`;
      return title;
    },
  },
};
</script>

<style lang="scss" scoped>
.suggestion-details-campaigns {
  margin: 40px 0;

  &__audience-name {
    color: $gray-800;
    font-size: 12px;
    font-weight: 500;
  }

  &__total-message {
    color: $oto-omni;
    text-decoration: underline;
    font-size: 12px;
    font-weight: 400;
    cursor: pointer;

    img {
      margin-right: 8px;
    }
  }

  &__empty-message {
    display: flex;

    img {
      width: 15px;
      margin-right: 8px;
    }

    a {
      text-decoration: underline;
    }

    span {
      display: block;
    }
  }

  .sdc__table {
    overflow-y: scroll;
    padding-top: 5px;
  }

  .table {
    font-size: 12px;
    margin: 0;

    .table__header,
    .table__body {
      .table__row {
        &--first {
          color: $gray-600;
        }
        color: $gray-800;
        display: grid;
        grid-template-columns: 38% 16% 18% 13% 8% 6%;
        justify-items: start;
        align-items: center;
      }
      .tooltip-overview {
        cursor: pointer;
      }
    }

    .table__header {
      font-weight: 600;
      .table__row {
        border-bottom: 1px solid $gray-300;
      }
    }

    .table__body {
      .table__row {
        grid-auto-columns: 80px;
        border-bottom: 1px solid $gray-400;

        &:last-child {
          border-bottom: none;
        }

        .table__column {
          padding-right: 15px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          width: 95%;

          &:first-child {
            padding: 8px 0;
          }

          span {
            .bol {
              border-radius: 50%;
              display: inline-block;
              height: 9px;
              width: 9px;
              margin-right: 10px;
            }

            .status-0 {
              background: $gray-500;
            }

            .status-1 {
              background: #35ba9b;
            }

            .status-2 {
              background: $pink-500;
            }
          }
        }
      }
    }

    .table__header-title {
      display: inline-block;
      width: fit-content;
      white-space: initial;
      margin-right: 5px;
    }

    .table__order-by {
      background-color: $gray-400;
      border-radius: 5px;
      cursor: pointer;
      display: inline-block;
      vertical-align: middle;
      line-height: 100%;
      padding: 3px 0;
      height: 18px;
      width: 18px;
      min-width: 18px;
      text-align: center;

      .table__dash-arrows {
        display: block;
        color: $color-white;
        border: solid $gray-900;
        border-width: 0 1px 1px 0;
        border-radius: 0;
        display: inline-block;
        padding: 3px;
        transform: translate(0, -50%) rotate(45deg);
      }

      &--active {
        background-color: $oto-seller;

        .table__dash-arrows {
          border-color: $color-white;
        }

        .table__dash-arrows {
          &--asc {
            transform: translate(0, -50%) rotate(45deg);
          }
          &--desc {
            transform: rotate(-135deg);
          }
        }
      }
    }
  }

  .sdc__header {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
  }

  .sdc__empty-wrapper {
    display: flex;
    align-items: center;
  }

  button.sdc__add-campaign {
    font-weight: normal;
    text-decoration: underline;
  }
}
.sdc__tooltip {
  cursor: pointer;
}
.v-popper--theme-tooltip .v-popper__inner {
  .content {
    display: block;
    justify-content: center;

    .title {
      padding-bottom: 10px;

      span {
        color: $gray-800;
        font-weight: 700;
        font-size: 14px;
      }
    }
  }
}
</style>
